/* Clouds
 * 雲.
 */
import * as THREE from "three";
import {Scene} from "./View3dScene";
import {Cameras} from "./View3dCamera";

export class Clouds {
    private _geometry: THREE.BufferGeometry;
    private _textures: THREE.Texture[];
    private _material: THREE.MeshBasicMaterial;
    private _mesh: THREE.Mesh;
    private _lastTimeStamp: number;
    private _interval: number;
    private _night: boolean;

    public get mesh(): THREE.Mesh { return this._mesh; }

    constructor() {
        this._geometry = new THREE.SphereGeometry(80, 80, 16, 16);
        this._geometry.scale(- 1, 1, 1);

        // THREE.ImageUtils.crossOrigin = "*";
        THREE.TextureLoader.prototype.crossOrigin = "*";
        this._textures = [];
        const texLoader = new THREE.TextureLoader();
        texLoader.crossOrigin = '';

        const getTexture = (num: number, isCloud: boolean) => {
            this._textures[num] = texLoader.load(this.getCloudTextureUrl(isCloud));
            this._textures[num].wrapS = THREE.RepeatWrapping;
            this._textures[num].wrapT = THREE.RepeatWrapping;
            this._textures[num].repeat.set(1, 1);
        }
        getTexture(0,false);
        getTexture(1,true);

        this._material = new THREE.MeshBasicMaterial();
        this._material.color = new THREE.Color(0x999999);
        this._material.transparent = true;
        this.night = false;

        this._mesh = new THREE.Mesh(<THREE.BufferGeometry>(this._geometry), this._material);
        this._mesh.name = "雲";

        this._mesh.userData = { type: "Environment" };

        this._lastTimeStamp = 0;
        this._interval = 800;
    }

    public getCloudTextureUrl(isNight: boolean): string {
        return isNight ? "texture3d/stars.png" : "texture3d/cloud.png";
    }
    public set night(value: boolean) {
        this._night = value;
        this._material.map = this._textures[value ? 1 : 0];
    }
    public get night(): boolean {
        return this._night;
    }
    public apply(scene: Scene) {
        scene.me.add(this._mesh);
    }
    public reset(scene: Scene) {
        scene.me.remove(this._mesh);
    }
    /* update
     * 描画前のアップデート.
     */
    public update(cameras: Cameras, timeStamp: number) {
        let time = (new Date).getTime();
        if (time - this._lastTimeStamp > this._interval) {
            this._mesh.rotation.y += Math.PI / 1080;
            this._lastTimeStamp = time;
        }
    }
}
